import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';

import { useTranslation } from '@lt/localization';
import Icon from 'src/components/Icon';
import { PAGES, PACKAGE_HOME_PATH } from 'checkout/store/constants';
import { getPath, getIsHomePath } from 'checkout/store/selectors/router';
import { goToPathAction } from 'checkout/store/actions/view';
import {
  getCompletedStep,
  getOrderIsFinished,
} from 'checkout/store/selectors/order';
import { getIsManualPackage } from 'checkout/store/selectors/package';
import { getFullPath } from 'checkout/utils/globalUtils';
import SidebarMenuPayment from './SidebarMenuPayment';

const baseCls = 'checkout-sidebar-menu';
const orderCreatedCls = `${baseCls}--order-created`;
const itemCls = `${baseCls}__item`;

const SidebarMenu = ({
  current,
  goToPath,
  completedStep,
  isManualPackage,
  isHomePath,
  isOrderFinished,
  isHotelOnly,
}) => {
  const { t } = useTranslation();
  const menuItems = PAGES.map(({ path, menuText, manualFlightMenuText }) => ({
    path,
    text: isManualPackage ? manualFlightMenuText || menuText : menuText,
  })).filter(({ path }) => !isHotelOnly || path !== PACKAGE_HOME_PATH);

  return (
    <ul className={cn(baseCls, { [orderCreatedCls]: isOrderFinished })}>
      {menuItems.map(({ path, text }, index) => {
        if (!text || index < completedStep) {
          return null;
        }

        const isCurrent = getFullPath(path) === current;
        const className = cn(itemCls, {
          [`${itemCls}_current`]: isCurrent,
          [`${itemCls}_current--without_flights`]:
            isManualPackage && isHomePath,
        });

        return (
          <li key={path} className={className}>
            {isCurrent ? (
              <>
                <span>{text}</span>

                <Icon
                  className={`${baseCls}__arrow`}
                  type="sidebar-menu-active"
                />
              </>
            ) : (
              <button type="button" onClick={() => goToPath(path)}>
                {text}
              </button>
            )}
          </li>
        );
      })}
      {/* TODO: отрефакторить этот хреновое меню */}
      <li className={itemCls}>
        {isOrderFinished ? (
          <span>
            {t('checkout.sidebar.orderFinished')}
            <span className="lt-icon-success lt-icon-success__small">
              <i className="lt-icon-success__check" />
            </span>
          </span>
        ) : (
          <SidebarMenuPayment />
        )}
      </li>
    </ul>
  );
};

SidebarMenu.propTypes = {
  current: PropTypes.string.isRequired,
  goToPath: PropTypes.func.isRequired,
  completedStep: PropTypes.number.isRequired,
  isManualPackage: PropTypes.bool.isRequired,
  isHomePath: PropTypes.bool.isRequired,
  isOrderFinished: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  current: getPath(state),
  completedStep: getCompletedStep(state),
  isManualPackage: getIsManualPackage(state),
  isHomePath: getIsHomePath(state),
  isOrderFinished: getOrderIsFinished(state),
});

const mapDispatchToProps = (dispatch) => ({
  goToPath: (to) => dispatch(goToPathAction(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);
